import React from "react";

const DeleteIcon = ({ fill="none", stroke="#ED4C78", ...props}) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
   <path
      d="M14.0625 4.6125L13.644 11.3794C13.5374 13.1081 13.4841 13.9727 13.05 14.5944C12.8358 14.9016 12.5599 15.1609 12.24 15.3558C11.5941 15.75 10.728 15.75 8.996 15.75C7.26125 15.75 6.39387 15.75 5.74655 15.3551C5.42652 15.1599 5.15067 14.9001 4.93655 14.5924C4.5032 13.97 4.45055 13.104 4.3466 11.3726L3.93755 4.6125M2.92505 4.6125H15.075M11.7378 4.6125L11.2768 3.6621C10.971 3.0303 10.8178 2.71508 10.5539 2.51798C10.4953 2.47431 10.4332 2.43549 10.3683 2.40187C10.076 2.25 9.725 2.25 9.02367 2.25C8.30412 2.25 7.94435 2.25 7.64667 2.40795C7.58087 2.44319 7.51811 2.48383 7.45902 2.52945C7.1924 2.73398 7.04322 3.06135 6.74487 3.71543L6.33582 4.6125M7.31255 12.0375V7.9875M10.6875 12.0375V7.9875"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DeleteIcon;
